import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import es from 'vuetify/lib/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    light: true ,
    themes: {
      dark: {
        primary: '#10B981', // Emerald 500
        secondary: '#64748B', // Slate 500
        accent: '#8B5CF6', // Violet 500
        info: '#3B82F6', // Blue 500
      },
      light: {
        primary: '#059669', // Emerald 600
        secondary: '#475569', // Slate 600
        tertiary: '#F8FAFC', // Slate 50
        accent: '#F1F5F9', // Slate 100
        error: '#EF4444', // Red 500
        info: '#0EA5E9', // Sky 500
        success: '#10B981', // Emerald 500
        warning: '#F59E0B', // Amber 500
      }
    },
    
  },
  lang: {
    locales: { es },
    current: 'es',
  },
  icons:{
    logo: "../assets/icono.ico",
  },
});
